export enum HealixGender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
  NotSpecified = 'Not Specified',
  Unknown = 'Unknown',
}
